import {createRouter, createWebHistory} from "vue-router";
import SideMenu from "../layouts/SideMenu/SideMenu.vue";
import DashboardOverview1 from "../pages/DashboardOverview1.vue";
import Onboarding from "../pages/Onboarding.vue";
import CallbackPage from "../pages/public/callback/index.vue";
import {getCookie, getCurrentUser, getJwtBody, setCurrentUser} from '../utils/cookie'


import ManagerReport from "@/pages/manager/report/index.vue";
import ManagerUserList from "@/pages/manager/users/list/index.vue";
import ManagerSupportTicket from "@/pages/manager/support/ticket/list/index.vue";
import ManagerSupportTicketDetail from "@/pages/manager/support/ticket/detail/index.vue";
import ManagerSupportDepartment from "@/pages/manager/support/department/index.vue";
import ManagerFinancialWallet from "@/pages/manager/financial/wallet/index.vue";
import ManagerFinancialIPG from "@/pages/manager/financial/ipg/index.vue";
import ManagerFinancialPricing from "@/pages/manager/financial/pricing/index.vue";
import ManagerViewVMServer from "@/pages/manager/vm/view/index.vue";
import ManagerListVMServer from "@/pages/manager/vm/list/index.vue";
import ManagerRBACList from "@/pages/manager/rbac/list/index.vue";
import ManagerRBACAssigment from "@/pages/manager/rbac/assignment/index.vue";
import CreateVMServer from "@/pages/vm/create/index.vue";
import ManagerCloudPricing from "@/pages/manager/cloud/buy-pricing/index.vue";
import ManagerCloudDomainPricing from "@/pages/manager/cloud/sell-pricing/index.vue";
import ManagerCloudList from "@/pages/manager/cloud/list/index.vue";

import ViewVMServer from "@/pages/vm/view/index.vue";
import ListVMServer from "@/pages/vm/list/index.vue";
import ticketListPage from "@/pages/ticket/list/index.vue";
import ticketDetailPage from "@/pages/ticket/detail/index.vue";
import AccountPage from "@/pages/account/index.vue";
import Login from "../pages/Login.vue";
import AuthCallback from "../pages/auth/callback/index.vue";
import Template from "../pages/Template.vue";
import Modal from "../pages/Modal.vue";
import ErrorPage from "../pages/ErrorPage.vue";
import Wallet from "../pages/financial/Wallet.vue";
import Transactions from "../pages/financial/Transactions.vue";
import Invoices from "../pages/financial/Invoices.vue";

const routes = [
    {
        path: "/",
        component: SideMenu,
        meta: {requiresAuth: true},
        children: [
            {
                path: "account",
                name: "account-page",
                component: AccountPage,
            },
            {
              path: 'account/wallet',
              name: "account.wallet",
              component: Wallet,
            },
            {
              path: 'account/transaction',
              name: "account.transaction",
              component: Transactions,
            },
            {
              path: 'account/invoice',
              name: "account.invoice",
              component: Invoices,
            },
            {
                path: "/",
                name: "side-menu-dashboard-overview-1",
                component: DashboardOverview1,
            },
            {
                path: "notification",
                name: "side-menu-notification",
                component: Notification,
            },
            {
                path: "vm/create",
                name: "side-menu-create-vm-server",
                component: CreateVMServer,
            },
            {
                path: "vm",
                name: "side-menu-list-vm-server",
                component: ListVMServer,
            },
            {
                path: 'vm/:id',
                name: "side-menu-view-vm-server",
                component: ViewVMServer
            },
            {
                path: "ticket/list",
                name: "ticket-list",
                component: ticketListPage,
            },
            {
                path: 'ticket/:id',
                name: 'ticket-detail',
                component: ticketDetailPage
            },

            {
                path: "/template",
                name: "template",
                meta: {requiresAuth: true},
                component: Template,
            },
            {
                path: "/modal",
                name: "modal",
                meta: {requiresAuth: true},
                component: Modal,
            },
        ],
    },
    {
        path: "/manager",
        component: SideMenu,
        meta: {requiresAuth: true},
        children: [
            {
                path: "report",
                name: "manager-report",
                component: ManagerReport,
            },
            {
                path: "user",
                name: "manager-users",
                meta: {requiresAuth: true},
                children: [
                    {
                        path: "list",
                        name: "manager-users-list",
                        component: ManagerUserList,
                    },
                ],
            },
            {
                path: "financial",
                name: "manager-financial",
                meta: {requiresAuth: true},
                children: [
                    {
                        path: "wallet",
                        name: "manager-financial-wallet",
                        component: ManagerFinancialWallet,
                    },
                    {
                        path: "ipg",
                        name: "manager-financial-ipg",
                        component: ManagerFinancialIPG,
                    },
                    {
                        path: "pricing",
                        name: "manager-financial-pricing",
                        component: ManagerFinancialPricing,
                    },
                ],
            },
            {
                path: "support",
                name: "manager-support",
                meta: {requiresAuth: true},
                children: [
                    {
                        path: "ticket",
                        name: "manager-support-ticket",
                        component: ManagerSupportTicket,
                    },
                    {
                        path: 'ticket/:id',
                        name: 'manager-support-ticket-detail',
                        component: ManagerSupportTicketDetail
                    },
                    {
                        path: "department",
                        name: "manager-support-department",
                        component: ManagerSupportDepartment,
                    },
                ],
            },
            {
                path: "vm",
                name: "manager-vm",
                meta: {requiresAuth: true},
                children: [
                    {
                        path: "list",
                        name: "manage-side-menu-list-vm-server",
                        component: ManagerListVMServer,
                    },
                    {
                        path: ':id',
                        name: "manage-side-menu-view-vm-server",
                        component: ManagerViewVMServer
                    },
                ],
            },
            {
                path: "rbac",
                name: "manager-rbac",
                meta: {requiresAuth: true, roles: "root"},
                children: [
                    {
                        path: "list",
                        name: "manager-rbac-roles",
                        component: ManagerRBACList,
                    },
                    {
                        path: "assignment/:id",
                        name: "manager-rbac-assignment",
                        component: ManagerRBACAssigment,
                    },
                    // {
                    //     path: 'tasks',
                    //     name: "manage-side-menu-task",
                    //     component: ManagerRBACRole
                    // },
                    // {
                    //     path: 'permissions',
                    //     name: "manage-side-menu-permission",
                    //     component: ManagerRBACPermissions
                    // },
                    // {
                    //     path: 'routes',
                    //     name: "manage-side-menu-routes",
                    //     component: ManagerRBACRoutes
                    // },
                ],
            },
            {
                path: "cloud",
                name: "manager-cloud",
                meta: {requiresAuth: true, roles: ['CloudAdmin']},
                children: [
                    {
                        path: "list",
                        name: "manage-side-menu-cloud-list",
                        component: ManagerCloudList,
                    },
                    {
                        path: "hardware-pricing",
                        name: "manage-side-menu-cloud-pricing",
                        component: ManagerCloudPricing,
                    },
                    {
                        path: "sell-pricing",
                        name: "manage-side-menu-domain-pricing",
                        component: ManagerCloudDomainPricing,
                    },
                ],
            },
        ],
    },
    {
        path: "/auth/callback",
        name: "auth-callback",
        meta: {requiresAuth: false},
        component: AuthCallback,
    },
    {
        path: "/login",
        name: "login",
        meta: {requiresAuth: false},
        component: Login,
    },
    {
        path: "/onboarding",
        name: "onboarding",
        meta: {requiresAuth: false},
        component: Onboarding,
    },
    {
        path: '/callback/:slug',
        name: 'callback',
        component: CallbackPage
    },
    {
        path: "/:pathMatch(.*)*",
        component: ErrorPage,
    },

];

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
        return savedPosition || {left: 0, top: 0};
    },
});


// Global navigation guard
router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {

        // This route requires auth, check if logged in
        // If not, redirect to login page.
        const utn = getCookie('utn');
        const user = getCurrentUser();
        if (utn && user) {
            const jwtBody = getJwtBody()
            const requireOnboarding = !jwtBody?.isMobileValidated || !jwtBody?.profile.isNationalCodeValidated

            if (requireOnboarding) {
                next({
                    path: '/onboarding',
                    query: {redirect: to.fullPath}, // Store the full path to redirect back after login
                });
            }
            if (to.meta?.roles instanceof Array) {
                const userRoles = jwtBody?.selectedSpace?.SpaceRoles.map(x => x.role)
                const routeRoles: string[] = to.meta?.roles || []
                routeRoles.push('root')
                const hasAccess = userRoles?.map(x => routeRoles.includes(x)).filter(x=>x).length
                if(!hasAccess) next('/')
            }


            next();
        } else {
            setCurrentUser(null);
            next({
                path: '/login',
                query: {redirect: to.fullPath}, // Store the full path to redirect back after login
            });
        }
    } else {
        next(); // Doesn't require auth, proceed as normal
    }
});

export default router;
